import axios from 'axios';

const API_BASE_URL = 'https://bangaloremetronews.in/bangaloremetroapp/news_back_end_laravel/public/api/api/v1';

export const imagaeAPI = 'https://bangaloremetronews.in/bangaloremetroapp/news_back_end_laravel/public'





const api = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    }
});

api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

api.interceptors.response.use(
    response => response,
    error => {
        if (error.response?.status === 401) {
            const currentPath = window.location.pathname;
            // List of public routes that should NOT redirect
            const publicPaths = ['/', '/homepage', '/login'];
            if (!publicPaths.includes(currentPath)) {
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                window.location.href = '/homepage';
            }
            // If on a public route, just reject so the component can handle the error
        }
        console.error('API Error:', error.response?.data || error.message);
        return Promise.reject(error);
    }
);



export const bannerAPI = {
    getAll: () => api.get('/banners'),
    getById: (id) => api.get(`/banners/${id}`),
    create: (data) => api.post('/banners', data, {
        headers: { 'Content-Type': 'multipart/form-data' }
    }),
    update: (id, data) => api.post(`/banners/${id}?_method=PUT`, data, {
        headers: { 'Content-Type': 'multipart/form-data' }
    }),
    delete: (id) => api.delete(`/bannersdelete/${id}`)

};

export const newsAPI = {
    getAll: () => api.get('/news'),
    getById: (id) => api.get(`/newsget/${id}`),
    create: (data) => api.post('/news', data, {
        headers: { 'Content-Type': 'multipart/form-data' }
    }),
    update: (id, data) => api.post(`/newsupdate/${id}?_method=PUT`, data, {
        headers: { 'Content-Type': 'multipart/form-data' }
    }),
    delete: (id) => api.delete(`/newsdelete/${id}`)
};

export const adsAPI = {
    getAll: () => api.get('/ads'),
    create: (data) => api.post('/ads', data, {
        headers: { 'Content-Type': 'multipart/form-data' }
    }),
    update: (id, data) => api.post(`/adsupdate/${id}?_method=PUT`, data, {
        headers: { 'Content-Type': 'multipart/form-data' }
    }),
    delete: (id) => api.delete(`/adsdelete/${id}`)
};


export const videoAPI = {
    getAll: () => api.get('/videos'),
    getById: (id) => api.get(`/videos/${id}`),
    create: (data) => api.post('/videos', data),
    update: (id, data) => api.put(`/videosupdate/${id}`, data),
    delete: (id) => api.delete(`/videosdelete/${id}`)
};

export const YouTubevideoAPI = {
    getAll: () => api.get('/youtube-videos'),

};

export const YouTubevideoMetroAPI = {
    getAll: () => api.get('/youtube-videos-metro'),

};

export const BengaluruNewsAPI = {
    getAll: () => api.get('/bengaluru-news'),

};

export const KarnatakaNewsAPI = {
    getAll: () => api.get('/karnataka-news'),

};

export const NationalNewsAPI = {
    getAll: () => api.get('/national-news'),

};

export const EntertainmentNewsAPI = {
    getAll: () => api.get('/entertainment-news'),

};

export const LifeStyleNewsAPI = {
    getAll: () => api.get('/life-style-news'),

};


export const bmrclAPI = {
    getAll: () => api.get('/bmrcl-news'),

};

export const bbmpAPI = {
    getAll: () => api.get('/bbmp-news'),

};

export const bdaAPI = {
    getAll: () => api.get('/bda-news'),

};

export const HealthAPI = {
    getAll: () => api.get('/health-news'),

};

export const SportAPI = {
    getAll: () => api.get('/sport-news'),

};

export const WorldAPI = {
    getAll: () => api.get('/world-news'),

};

export const TechAPI = {
    getAll: () => api.get('/tech-news'),

};

export const FoodAPI = {
    getAll: () => api.get('/food-news'),

};

export const EnvAPI = {
    getAll: () => api.get('/env-news'),

};

export const roleAPI = {
    getAll: () => api.get('/roles'),
    getById: (id) => api.get(`/roles/${id}`),
    create: (data) => api.post('/roles', data),
    update: (id, data) => api.put(`/roles/${id}`, data),
    delete: (id) => api.delete(`/roles/${id}`),
    updateStatus: (id, status) => api.put(`/roles/${id}/status/${status}`),

};

export const authAPI = {
    login: (data) => api.post('/login', data),
    logout: () => api.post('/logout'),
    me: () => api.get('/me'),
    changePassword: (data) => api.post('/change-password', data),
    updateProfile: (data) => api.put('/update-profile', data)
};













export default api;